<template>
    <div class="news-info">
        <Head />
        <div class="banner" >
            <div class="banner-bg" :style="{
                backgroundImage: `url(${$appUrl.imgHost+detailInfo.info.cover_path})`
            }">
                <!-- <img :src="detailInfo.info.cover_path" alt=""> -->
            </div>
            <div class="mask">
                <h3>{{detailInfo.info.title}}</h3>
                <div class="tab">
                    <ul>
                        <li>{{$t('newscource')}}</li>
                        <li class="time" >{{detailInfo.info.create_time | timeFomatter}}</li>
                        <li class="share-img" @click="goShare('facebook')">
                            <img src="../../assets/icon/news_share1.png" alt="">
                            <img class="share-hover" src="../../assets/icon/news_share1_hover.png" alt="">
                        </li>
                        <li class="share-img" @click="goShare('linkedin')">
                            <img src="../../assets/icon/news_share2.png" alt="">
                            <img class="share-hover" src="../../assets/icon/news_share2_hover.png" alt="">
                        </li>
                        <li class="share-img" @click="goShare('twitter')">
                            <img src="../../assets/icon/news_share3.png" alt="">
                            <img class="share-hover" src="../../assets/icon/news_share3_hover.png" alt="">
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="content node-anchor">
            <div class="text-box" v-html="detailInfo.info.content">
            </div>
        </div>
        <Footer />
    </div>
</template>
<script>
import Head from '../../components/head';
import Footer from '../../components/footer';
import api from '../../api/news';

export default {
    components: {
        Head,
        Footer
    },
    created() {
        if (this.$route.query.id) {
            this.id = this.$route.query.id;
        } else {
            this.id = 555;
        }
        this.getNewsDetail();
    },
    data() {
        return {
            style: {
                backgroundImage: "url('/Uploads/Editor/2020-10-15/5f879f973e714.png')"
            },
            id: '',
            detailInfo: {
                info: {},
                category: {},
            },
        }
    },

    methods: {
        getNewsDetail() {
            api.newsDetail(this.id).then(res => {
                if(res.info) {
                    res.info.content = res.info.content.replace(/\/Uploads\//g, this.$appUrl.imgHost + '/Uploads/');
                }
                this.detailInfo = res;
            });
        },
        goShare(type){
            let url = '';
            let shareurl = location.href; //`${window.location.protocol}//${window.WWW_HOST}/newsinfo?${this.id}`;
            switch (type){
                case 'facebook':
                    url =  `http://www.facebook.com/sharer.php?u=${shareurl}`;
                    break;
                case 'linkedin':
                    url =  `http://www.linkedin.com/shareArticle?url=${shareurl}`;
                    break;
                case 'twitter': 
                    url = `http://twitter.com/share?url=${shareurl}`;
                    
                    break;
            }
            window.open(url)
        }
    }
    
}
</script>

<style lang="less">
.news-info {
    .banner {
        height: 350px;
        position: relative;
        .banner-bg {
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
            filter: blur(6px);
            position: absolute;
            left: 0;
            top: 0;
            bottom: 3px;
            right: 0;
            text-align: center;
            img {
                display: inline-block;
                width: 100%;
                height: 100%;
                max-height: 350px;
                max-width: 100%;
            }
        }
        .mask {
            position: relative;
            box-sizing: border-box;
            padding-top: 140px;
            width: 100%;
            height: 100%;
            background: linear-gradient(133deg, rgba(52,57,178, 0.8) 0%, rgba(43,54,162, 0.8) 100%);
            h3 {
                font-size: 36px;
                width: 1200px;
                margin: 0 auto;
                color: #ffffff;
            }
            .tab {
                width: 1200px;
                margin: 0 auto;
                padding-top: 45px;
                ul {
                    font-family: HelveticaNeue, Arial;
                    display: flex;
                    color: #ffffff;
                    align-items: center;
                    .time {
                        margin-left: 28px;
                    }
                    .share-hover {
                        display: none;
                    }
                    .share-img {
                        margin-left: auto;
                        width: 44px;
                        height: 44px;
                        cursor: pointer;
                        &:hover {
                            img {
                                display: none;
                            }
                            img~img {
                                display: block;
                            }
                        }
                        img {
                            width: 100%;
                        }
                    }

                    .share-img~.share-img{
                        margin-left: 30px;
                    }
                }
            }
        }
    }
    .content {
        width: 100%;
        padding: 60px 0 150px;
        .text-box {
            margin: 0 auto;
            width: 1200px;
            p {
                font-family: Helvetica, Arial, sans-serif!important;
                color: #333333!important; 
                line-height: 34px;
                font-size: 16px!important;
            }
            img {
                display: inline-block;
                margin: 16px;
                max-width: 840px;
            }
        }
    }
}

</style>